import React from 'react';
import { ExerciseImage } from 'components/ExerciseImage';
import styled from 'styled-components';
import { P2 } from 'styleguide/Texts';
import { getSupersetColor } from 'styleguide/colors';
import { ExerciseInnerProps, ExerciseProps } from '../types';
import { CornerRadius, Spacing } from 'styleguide/spacing';
import { View } from 'styleguide/View';
import { FlexRow } from 'styleguide/Row';

const Container = styled(View)`
  height: 100%;
  display: flex;
  justify-content: space-between;
`;

const InnerContainer = styled(View)`
  gap: ${Spacing.md}px;
`;

const ExercisesContainer = styled(View)`
  gap: ${Spacing.md}px;
`;

interface ExercisesProps {
  exercises: ExerciseProps[];
  truncatedExercisesTitle?: string;
}

export const Exercises = ({ exercises, truncatedExercisesTitle }: ExercisesProps) => {
  return (
    <Container>
      <InnerContainer>
        <ExercisesContainer>
          {exercises.map(e => (
            <Exercise key={e.key} superset={e.superset} image={e.image} title={e.title} />
          ))}
        </ExercisesContainer>
      </InnerContainer>

      {truncatedExercisesTitle && (
        <P2 type="secondary" style={{ marginTop: Spacing.md }}>
          {truncatedExercisesTitle}
        </P2>
      )}
    </Container>
  );
};

const Exercise = ({ superset, image, title }: ExerciseInnerProps) => {
  return (
    <FlexRow>
      {superset !== undefined && <SupersetSliver superset={superset} />}
      <ExerciseImage source={image} diameter={48} />
      <P2 style={{ marginInlineStart: Spacing.sm }}>{title}</P2>
    </FlexRow>
  );
};

interface SupersetSliverProps {
  superset: number;
}

const SupersetSliver = ({ superset }: SupersetSliverProps) => (
  <div
    style={{
      display: 'flex',
      backgroundColor: getSupersetColor(superset),
      width: Spacing.xs,
      height: 48,
      borderRadius: CornerRadius.xs,
      marginInlineEnd: Spacing.sm,
    }}
  />
);
